import React from "react";
import {injectIntl} from "react-intl";
import Modal from "@Components/Modal";

function ModalList({intl, id, branchData, onClose}) {
    const specs = {};
    let addSpecsData = (phones, names) => {
        for (let index = 0; index < phones.length; index++) {
            let specsName = names[index].toLowerCase();
            let specsPhone = phones[index];
            if (specs.hasOwnProperty(specsName)) {
                if(!specs[specsName].includes(specsPhone)) {
                    specs[specsName].push(specsPhone);
                }
            } else {
                specs[specsName] = [specsPhone];
            }
        }
    }

    //Adding main office phone and specialism if they exist
    if(branchData.main_office_phone && branchData.main_office_spec) {
        addSpecsData(branchData.main_office_phone, branchData.main_office_spec);
    }

    //Adding related offices phones and specialisms if they exist
    if(branchData.related_office_phones && branchData.related_office_spec_names) {
        addSpecsData(branchData.related_office_phones, branchData.related_office_spec_names);
    }

    return (
        <>  
				<Modal title={intl.formatMessage({id: "Branches.ModalTitle"}) + branchData.title} id={id} onClose={onClose}>
            <div className="list-item__info mt-none l:mb-none">
              <ul className="modal__address text--alternative">
                  <li key={`address_line1_${id}`}>{branchData.address_line1}</li>
                  <li key={`locality_${id}`}>{ (branchData.postal_code || '') + ' ' + (branchData.locality || '')}</li>
              </ul>

              {specs &&
                  <div className="related-office-wrapper">
                      <ul key={id}>
                          {
                              Object.keys(specs).map((specialism, index) => {
                                  return (
                                  <li key={index} className="mt-s">
                                      {specialism} {specs[specialism].map((phone, index) => <a key={index} href={`tel:${phone}`} className="display-block text-brand-primary mt-xxs"> {phone}</a>)}
                                  </li>
                                  )
                              })
                          }
                      </ul>
                  </div>
              }
          </div>
        </Modal>
        </>
    );
}

export default injectIntl(ModalList);